module.exports = __webpack_public_path__ + "assets/img/e217-gs.svg";